import { render } from "./IconMenuBarcode.vue?vue&type=template&id=496efaa8"
import script from "./IconMenuBarcode.vue?vue&type=script&lang=ts"
export * from "./IconMenuBarcode.vue?vue&type=script&lang=ts"
script.render = render

export default script